angular.module('picmonic-common')
    .factory("PackageOptionsResource", ['$resource', function($resource){
        return $resource("/api/v3/package_options");
    }]);